/**
 * 处理Markdown中的链接和图片元素的完整性
 */
import { LogDebugFunction } from '../utils/markdownTypes';

/**
 * 处理普通链接
 */
export const processLink = (
  text: string, 
  startIdx: number, 
  charsToShow: number, 
  analyzedText: string,
  remainingText: string,
  logDebugInfo: LogDebugFunction
): number => {
  // 链接处理
  if (/\[[^\]]*$/.test(analyzedText)) {
    // 尝试找到完整的链接格式 [text](url)
    const linkMatch = remainingText.match(/^\[([^\]]*)\](\([^)]*\))?/);
    if (linkMatch) {
      if (linkMatch[2]) {
        // 完整链接
        const fullLink = linkMatch[0].length;
        if (charsToShow < fullLink) {
          return logDebugInfo('链接-完整', fullLink - charsToShow);
        }
      } else {
        // 至少显示到 [ 后的一个字符
        const minRequired = 2; // [ + 至少一个字符
        if (charsToShow < minRequired) {
          return logDebugInfo('链接-前缀', minRequired - charsToShow);
        }
      }
    }
  }
  
  return 0;
};

/**
 * 处理图片链接
 */
export const processImageLink = (
  text: string, 
  startIdx: number, 
  charsToShow: number, 
  analyzedText: string,
  remainingText: string,
  logDebugInfo: LogDebugFunction
): number => {
  // 图片处理
  if (/!\[[^\]]*$/.test(analyzedText)) {
    // 尝试找到完整的图片格式 ![alt](url)
    const imageMatch = remainingText.match(/^!\[([^\]]*)\](\([^)]*\))?/);
    if (imageMatch) {
      if (imageMatch[2]) {
        // 完整图片链接
        const fullImage = imageMatch[0].length;
        if (charsToShow < fullImage) {
          return logDebugInfo('图片-完整', fullImage - charsToShow);
        }
      } else {
        // 至少显示到 ![ 后的一个字符
        const minRequired = 3; // ![ + 至少一个字符
        if (charsToShow < minRequired) {
          return logDebugInfo('图片-前缀', minRequired - charsToShow);
        }
      }
    }
  }
  
  return 0;
}; 